// import { authHeader } from "../../utils/helpers/api";

// const axios = require("axios").default;

// export const request = async (method, url, data = null) => {
//   const authHead = authHeader();

//   try {
//     const config = {
//       method: method,
//       url: url,
//       // `${BASE_URL}/${url}`,
//       data: data,
//       headers: {
//         "Content-Type": "application/json",
//         ...authHead,
//       },
//     };
//     const response = await axios(config);
//     return response;
//   } catch (error) {
//     throw error.response.data;
//   }
// };
// request.js
import { authHeader } from "../../utils/helpers/api";
const axios = require("axios").default;

export const request = async (method, url, data = null) => {
  const authHead = authHeader();

  try {
    const config = {
      method,
      url,
      data,
      headers: {
        "Content-Type": "application/json",
        ...authHead,
      },
    };
    const response = await axios(config);
    return response;
  } catch (error) {
    // error.response is undefined on network/CORS errors
    const safe = (error && error.response && error.response.data) || {
      success: false,
      error: { message: error?.message || "Network error" },
    };
    throw safe;
  }
};
